export default __webpack_public_path__ + "static/media/orderBasket.c04a4fdb.svg";